<template>
  <ais-hits>
    <div slot-scope="{ items }">
      <slot name="row" :items="items"></slot>
      <div v-if="!items.length">
        <div class="p-4 border rounded">
          <h4>Sorry! We didn't find any results.</h4>
          If you would like to contribute, please reach out to {{contactName}} (<a :href="contactMail" >{{contactMail}}</a >).
        </div>
      </div>

      <div v-if="items.length">
        <slot name="footer"></slot>
        <d-row>
          <d-col class="text-center">
            <ais-pagination id="docs-pagination" :class-names="{
              'ais-Pagination-list': 'pagination',
              'ais-Pagination-item': 'page-item',
              'ais-Pagination-link': 'page-link',
              'ais-Pagination-item--selected': 'active',
            }" slot-scope="{ items }">  
          </ais-pagination>
        </d-col>
      </d-row>
    </div>
  </div>
</ais-hits>
</template>


<script>
  import { mapState } from 'vuex';
  export default {
    name: 'HitsTableView',
    props: {
      title: {
        type: String,
        default: '',
      },
      showPagination: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      hasFooterSlot() {
        return !!this.$slots.footer;
      },
      contactName() {
        return this.searchSettings.contact.name || 'Global Support';
      },
      contactMail() {
        return this.searchSettings.contact.mail || 'mailto:support@wwfint.org';
      },
    ...mapState(['searchSettings']),
    },
  };

</script>
